<template>
  <q-page padding>
    <!-- <base-form :resource="$route.meta.resource" /> -->
    <user-edit></user-edit>
  </q-page>
</template>

<script>
import UserEdit from '../../../components/custom/userEdit'

export default {
  inject: ['$validator'],
  name: 'AddForm',
  components: {UserEdit}
}
</script>

<style>
</style>
